import { useCallback, useState } from 'react';

/**
 * Un sí/no que sobrevive a recargar la página.
 *
 * Para preferencias de PANTALLA y nada más: «tenía la lista cerrada», «estaba
 * mirando esta pestaña». Nada que otra persona tenga que ver, nada que el
 * servidor tenga que saber. Lo que se guarda acá vive en ESE navegador: no
 * viaja al teléfono de la misma persona ni a la sesión de al lado.
 *
 * TODO ENVUELTO EN try/catch, y no por prolijidad. En una ventana privada, con
 * las cookies de sitio bloqueadas o dentro de algunas vistas incrustadas,
 * `localStorage` no devuelve vacío: TIRA al tocarlo. Sin el try/catch eso no
 * es «se me olvidó la preferencia», es la pantalla en blanco.
 */
export function useRemembered(key: string, initial: boolean): [boolean, (value: boolean) => void] {
  const [value, setValue] = useState<boolean>(() => {
    try {
      const guardado = window.localStorage.getItem(key);
      return guardado === null ? initial : guardado === '1';
    } catch {
      return initial;
    }
  });

  const cambiar = useCallback(
    (nuevo: boolean) => {
      setValue(nuevo);
      try {
        window.localStorage.setItem(key, nuevo ? '1' : '0');
      } catch {
        // Que no se recuerde es aceptable; que se caiga la pantalla no.
      }
    },
    [key],
  );

  return [value, cambiar];
}
